(() => {
  const ROOT_SELECTOR = '[data-giftbox]';

  function getShopRoot() {
    return (window.Shopify?.routes?.root || '/');
  }

  function extractPropertiesFromFormData(fd) {
    const props = {};
    for (const [k, v] of fd.entries()) {
      const m = /^properties\[(.+)\]$/.exec(k);
      if (m) props[m[1]] = v;
    }
    return props;
  }

  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return String(Date.now()) + '-' + Math.random().toString(16).slice(2);
  }

  async function fetchCart() {
    const res = await fetch(getShopRoot() + 'cart.js', { headers: { Accept: 'application/json' } });
    return await res.json();
  }

  // ✅ HORIZON bubble updater (твоя разметка: .cart-bubble / .cart-bubble__text-count)
  function updateCartCountUI(count) {
    const n = Number(count) || 0;

    // Horizon bubble
    const hzBubble = document.querySelector('.cart-bubble');
    if (hzBubble) {
      const countEl = hzBubble.querySelector('.cart-bubble__text-count');
      const srEl = hzBubble.querySelector('.cart-bubble__text .visually-hidden');

      const isEmpty = n <= 0;

      // empty => visually-hidden
      hzBubble.classList.toggle('visually-hidden', isEmpty);

      // empty => count span hidden
      if (countEl) {
        countEl.classList.toggle('hidden', isEmpty);
        countEl.textContent = isEmpty ? '' : (n > 99 ? '99+' : String(n));
      }

      // update SR text
      if (srEl) {
        const before = srEl.textContent || '';
        const replaced = before.replace(/:\s*\d+/, `: ${n}`);
        srEl.textContent = replaced !== before ? replaced : `Cart count: ${n}`;
      }

      // maintain ratio only for <= 99
      if (n <= 99) hzBubble.setAttribute('data-maintain-ratio', '');
      else hzBubble.removeAttribute('data-maintain-ratio');
    }

    // Fallbacks (если где-то ещё используются)
    const dawnBubble = document.querySelector('.cart-count-bubble');
    if (dawnBubble) {
      dawnBubble.style.display = n > 0 ? '' : 'none';
      const hidden = dawnBubble.querySelector('span[aria-hidden="true"]');
      if (hidden) hidden.textContent = String(n);
      const sr = dawnBubble.querySelector('span.visually-hidden');
      if (sr) sr.textContent = String(n);
    }

    document
      .querySelectorAll('[data-cart-count], [data-cart-count-bubble], .cart-count, .header__cart-count')
      .forEach((el) => {
        el.textContent = String(n);
      });
  }

  function findSectionWrapper(sectionId) {
    return (
      document.getElementById(`shopify-section-${sectionId}`) ||
      document.getElementById(sectionId) ||
      document.querySelector(`[data-section-id="${sectionId}"]`)
    );
  }

  function replaceSectionHTML(sectionId, html) {
    const current = findSectionWrapper(sectionId);
    if (!current || !html) return;

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const incoming =
      doc.getElementById(`shopify-section-${sectionId}`) ||
      doc.getElementById(sectionId) ||
      doc.querySelector(`[data-section-id="${sectionId}"]`) ||
      doc.body.firstElementChild;

    if (incoming) current.replaceWith(incoming);
  }

  function buildSectionsToRefresh() {
    // max 5
    const candidates = [
      'cart-drawer',
      'cart-notification',
      'cart-icon-bubble',
      'header',
      'cart-live-region-text'
    ];

    const existing = candidates.filter((id) => findSectionWrapper(id));
    return existing.slice(0, 5);
  }

  async function addItemsWithSections(items, sections) {
    const payload = { items };

    if (sections && sections.length) {
      payload.sections = sections.join(',');
      payload.sections_url = window.location.pathname;
    }

    const res = await fetch(getShopRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    const data = await res.json();
    if (!res.ok) {
      const msg =
        data && (data.description || data.message)
          ? `${data.message || ''} ${data.description || ''}`.trim()
          : 'Add to cart failed';
      throw new Error(msg);
    }
    return data;
  }

  function openCartUIIfPossible() {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') drawer.open();

    const notification = document.querySelector('cart-notification');
    if (notification && typeof notification.open === 'function') notification.open();
  }

  function getVariantIdFromForm(form) {
    const idInput = form.querySelector('input[name="id"]');
    return idInput ? Number(idInput.value) : 0;
  }

  function getQtyFromForm(form) {
    const qtyInput = form.querySelector('input[name="quantity"]');
    const qty = qtyInput ? Number(qtyInput.value) : 1;
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  }

  function getSellingPlanFromForm(form) {
    const el = form.querySelector('input[name="selling_plan"], select[name="selling_plan"]');
    return el && el.value ? el.value : null;
  }

  function buildBundledItems({ form, giftVariantId, mode }) {
    const mainVariantId = getVariantIdFromForm(form);
    if (!mainVariantId) return null;

    const mainQty = getQtyFromForm(form);
    const sellingPlan = getSellingPlanFromForm(form);

    const fd = new FormData(form);
    const props = extractPropertiesFromFormData(fd);

    const bundleId = uuid();
    props['_bundle_id'] = bundleId;
    props['_giftbox'] = 'Yes';

    const giftQty = mode === 'per_item' ? mainQty : 1;

    const mainItem = {
      id: mainVariantId,
      quantity: mainQty,
      properties: props
    };
    if (sellingPlan) mainItem.selling_plan = sellingPlan;

    const giftItem = {
      id: giftVariantId,
      quantity: giftQty,
      properties: {
        '_bundle_id': bundleId,
        '_giftbox_for_variant': String(mainVariantId)
      }
    };

    return [mainItem, giftItem];
  }

  function isBuyNowButton(el) {
    if (!el) return false;
    return (
      el.classList?.contains('shopify-payment-button__button') ||
      el.getAttribute?.('name') === 'checkout' ||
      el.closest?.('.shopify-payment-button') != null
    );
  }

  function flashAddedState(form) {
    const btn = form.querySelector('button[type="submit"], input[type="submit"]');
    if (!btn) return;

    const isInput = btn.tagName === 'INPUT';
    const prev = isInput ? btn.value : btn.textContent;

    if (isInput) btn.value = 'ADDED';
    else btn.textContent = 'ADDED';

    setTimeout(() => {
      if (isInput) btn.value = prev;
      else btn.textContent = prev;
    }, 900);
  }

  function findAllAddToCartForms() {
    return Array.from(document.querySelectorAll('form[action*="/cart/add"]'));
  }

  function bindToForm({ form, checkbox, giftVariantId, mode }) {
    if (!form || form.dataset.giftboxBound === '1') return;
    form.dataset.giftboxBound = '1';

    const handle = async (ev, action) => {
      // action: 'cart' | 'checkout'
      if (!checkbox.checked) return;

      ev.preventDefault();
      ev.stopImmediatePropagation();

      const items = buildBundledItems({ form, giftVariantId, mode });
      if (!items) return;

      const btns = Array.from(form.querySelectorAll('button, input')).filter((b) => {
        const t = (b.getAttribute('type') || '').toLowerCase();
        return t === 'submit' || b.classList?.contains('shopify-payment-button__button');
      });
      const prev = btns.map((b) => b.disabled);
      btns.forEach((b) => (b.disabled = true));

      try {
        const sections = buildSectionsToRefresh();
        const data = await addItemsWithSections(items, sections);

        // If theme has Dawn-like components that can render sections
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(data);
        }
        const notif = document.querySelector('cart-notification');
        if (notif && typeof notif.renderContents === 'function') {
          notif.renderContents(data);
        }

        // Otherwise replace returned sections directly
        if (data && data.sections) {
          for (const sectionId of Object.keys(data.sections)) {
            replaceSectionHTML(sectionId, data.sections[sectionId]);
          }
        }

        // Always refresh cart count from server and update bubble
        const cart = await fetchCart();
        updateCartCountUI(cart?.item_count ?? 0);

        if (action === 'checkout') {
          window.location.assign(getShopRoot() + 'checkout');
          return;
        }

        // Add to cart: stay on page
        openCartUIIfPossible();
        flashAddedState(form);
      } catch (err) {
        console.error(err);
        alert(err?.message || 'Unable to add packaging');
      } finally {
        btns.forEach((b, i) => (b.disabled = prev[i]));
      }
    };

    // submit (classic)
    form.addEventListener('submit', (e) => handle(e, 'cart'), true);

    // click interception (important for JS-handled themes)
    form.querySelectorAll('button, input[type="submit"]').forEach((btn) => {
      btn.addEventListener(
        'click',
        (e) => {
          if (!checkbox.checked) return;
          handle(e, isBuyNowButton(btn) ? 'checkout' : 'cart');
        },
        true
      );
    });
  }

  function init() {
    const root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;

    const checkbox = root.querySelector('[data-giftbox-checkbox]');
    const giftVariantId = Number(root.getAttribute('data-giftbox-variant'));
    const mode = (root.getAttribute('data-giftbox-mode') || 'per_order').toLowerCase();

    if (!checkbox || !giftVariantId) {
      console.warn('GiftBox: missing checkbox or gift variant id. Check GiftBox block settings (Packaging product).');
      return;
    }

    findAllAddToCartForms().forEach((form) => bindToForm({ form, checkbox, giftVariantId, mode }));
  }

  document.addEventListener('DOMContentLoaded', init);
})();